import { getInteractionIcon } from "@/common/helpers/interactionIconHelper";
import { InteractionListIconProps } from "./types";
import {
	useCallSessionStore,
	CallSessionState,
} from "@/common/stores/nonpersistingStores/callSession";
import { InteractionHandlingStatus } from "@/repository/models";
import { InteractionType } from "@/common/types";

export const InteractionListIcon = (props: InteractionListIconProps) => {
	const {
		interaction,
		interactionHandlingStatus,
		isHighLighted,
		hideUnreadIcon: hideUnreadStatus,
		hideDirectionArrow,
	} = props;

	const hasUnreadMessages = (isSimplified: boolean) => {
		return (
			interactionHandlingStatus !== InteractionHandlingStatus.Waiting &&
			(interaction.type === InteractionType.Email ||
				interaction.type === InteractionType.WhatsApp ||
				interaction.type === InteractionType.Webchat) &&
			interaction.isLastMessageSeen === false &&
			!isSimplified
		);
	};

	const callSession = useCallSessionStore(
		(state: CallSessionState) => state.callSession
	);

	const isMonitoredInteraction =
		(interaction.id === callSession?.id &&
			callSession.supervisorId !== null) ||
		interaction.isSupervised ||
		!!interaction.monitoringSupervisorId;

	const hasUnreadMessagesIcon = hasUnreadMessages(false);

	return getInteractionIcon(interaction, {
		isMonitoredInteraction,
		isHighlighted: isHighLighted,
		hasUnreadIcon: !hideUnreadStatus && hasUnreadMessagesIcon,
		hideDirectionArrow,
	});
};
